import { get, post, remove } from '@/api/base'

export const getUvvChecks = async containerUuid => {
  const response = await get({
    path: `containers/${containerUuid}/uvv_checks`,
  })
  return response.success ? response.data.uvv_checks : []
}

export const createUvvCheck = async (containerUuid, params) => {
  return await post({
    path: `containers/${containerUuid}/uvv_checks`,
    params,
  })
}

export const deleteUvvCheck = async (containerUuid, uvvCheckUuid) => {
  return await remove({
    path: `containers/${containerUuid}/uvv_checks/${uvvCheckUuid}`,
  })
}
